<template>
    <div style="padding: 10px 10px 10px 0;page-break-before: auto;page-break-after: always;">

        <el-dialog title="修改" :visible.sync="isChange" width="30%">
            <el-form :model="form">
                <el-form-item label="租金状态">
                    <el-select v-model="status" placeholder="状态" style="width: 100px;">
                        <el-option label="已缴费" value="已缴费"></el-option>
                        <el-option label="未缴费" value="未缴费"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isChange = false">关 闭</el-button>
                <el-button @click="isOk" type="primary">确 定</el-button>
            </span>
        </el-dialog>

        <el-form :inline="true" :model="form" class="demo-form-inline">
            <div class="flex sb">
                <div>
                    <el-form-item label="房间名">
                        <el-input size="small" v-model="form.roomName" placeholder="请输入商铺号" style="width: 150px;"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="缴费年月">
                        <el-date-picker size="small" value-format="yyyy-MM" v-model="form.time" type="month"
                            placeholder="选择年月" :clearable="true"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="getAll">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="querySeach">重置</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="dc">导出</el-button>
                    </el-form-item>
                </div>
            </div>
        </el-form>

        <el-table :data="data" style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column label="房间名" prop="roomName" align="center">
            </el-table-column>
            <el-table-column label="缴费年月" align="center">
                <template slot-scope="{row}">
                    <span>
                        {{ row.year + "-" + row.month }}</span>
                </template>
            </el-table-column>

            <el-table-column label="电费" prop="electricityPrice" align="center">
            </el-table-column>
            <el-table-column label="电费状态" prop="status" align="center">
                <template slot-scope="{row}">
                    <span>{{ row.status == 0 ? '未对账' : '已对账' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="水费" prop="waterPrice" align="center">
            </el-table-column>
            <el-table-column label="水费状态" prop="waterStatus" align="center">
                <template slot-scope="{row}">
                    <span>{{ row.waterStatus == 0 ? '未对账' : '已对账' }}</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="160" align="center">
                <template slot-scope="{row}">
                    <!-- <el-button type="text" @click="setRow(row,'1')">详情</el-button> -->
                    <el-button :disabled="row.status == 1 && row.waterStatus == 1" type="text"
                        @click="setRow(row)">对账</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination v-if="count > 0" :page-sizes="[10, 20, 30, 50]" :page-size="form.row" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="count">
        </el-pagination>

    </div>
</template>

<script>
import publicExport from '../../../assets/js/publicExport.js';
import downloadFile from '../../../assets/js/downloadFile.js';
import { setTimeout } from 'timers';
export default {
    // 注册组件
    components: {
    },
    data() {
        return {
            titleObj: {
                contractCode: "实缴金额",

            },
            paymentBillVos: [],
            count2: 0,
            selectForm2: {
                page: 1,
                row: 10,
                roomName: null, //商铺号
                startTime: null,
                endTime: null,
                type: null,
                isInvoice: null
            },
            show2: false,
            show3: false,
            activeName: "1",
            headers: {
                Authorization: localStorage.access_token
            },
            loading: false,
            sum: 0,
            count: 0,
            isDyxs: true,
            users: [], //申请人
            show: false,
            status: '',
            id: '',
            bdShopPayList: [],
            form: {
                "time": "", //开始时间
                "roomName": "", //商铺号
                "page": 1,
                "row": 10,
            },
            addForm: {},
            data: [],
            obj: {
                fileRes: "",
                applyTime: ""
            }, //详情数据
            isChange: false,
            show1: false, //控制筛选列的多选框
            oneRow: "", //当checkList列表只有一项时,选择框不可点击
            checkList: ["商铺号", "商铺名称", "联系人", "联系方式", "账期时间"
                , "租金", "租金增值税9%", "租金收入", "物业费", "物业增值税6%",
                "物业费收入", "推广费", "推广增值税6%", "推广费收入", "购电费", "水费", "应缴合计"],
            titleObj: {
                roomName: "商铺号",
                shopName: "商铺名称",
                name: "联系人",
                phone: '联系方式',
                appdate: '账期时间',
                money: "租金",
                rentalRevenue: "租金增值税9%",
                rentalIncome: "租金收入",
                wuyepay: "物业费",
                wuyeRevenue: "物业增值税6%",
                wuyeIncome: "物业费收入",
                promotionSum: "推广费",
                promotionRevenue: "推广增值税6%",
                promotionIncome: "推广费收入",
                electricPay: "购电费",
                waterPay: "水费",
                total: "应缴合计",
            },
            oldTitleObj: {
                roomName: "商铺号",
                shopName: "商铺名称",
                name: "联系人",
                phone: '联系方式',
                appdate: '账期时间',
                money: "租金",
                rentalRevenue: "租金增值税9%",
                rentalIncome: "租金收入",
                wuyepay: "物业费",
                wuyeRevenue: "物业增值税6%",
                wuyeIncome: "物业费收入",
                promotionSum: "推广费",
                promotionRevenue: "推广增值税6%",
                promotionIncome: "推广费收入",
                electricPay: "购电费",
                waterPay: "水费",
                total: "应缴合计",
            },
            roleId: "",
            data2: [],
            dataIds: [],
            title2: "",
            loading2: false,
        }
    },
    created() {
        this.roleId = localStorage.roleId
        this.getAll();
    },
    methods: {
        selectable(row, rowIndex) {
            if (row.kpStatus == '已开票') {
                return true;  //不禁用
            } else {
                return false;  //禁用
            }
        },
        handleSelectionChange(val) {
            this.paymentBillVos = val
            var ids = []
            val.forEach(row => {
                if (row.review == '未复核' && row.status == '已缴费' && row.wuyeStatus == '1' && row.promotionStatus == '1') {
                    ids.push(row.id)
                }
            });
            this.dataIds = ids
        },


        setRow(obj) {
            this.$confirm('是否确认对账?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$http.post(`/api/reconciliation/waterElsReconciliation`, { id: obj.id }).then(res => {
                    if (res.data.code == 0) {
                        this.getAll();
                        this.$message.success("对账成功");
                    } else {
                        this.$message.error(res.data.message);
                    }

                })
                // return delDeployment(ids);
            }).catch(() => {
                this.$message({
                    type: 'warning',
                    message: '已取消对账'
                });
            });

        },



        success(res) {
            if (res.code == 0) {
                this.getAll()
                this.$message.success("导入成功")
            } else {
                this.$message.error(res.message)
            }
        },
        addTemplate() { //下载导入模板
            this.$http.post(`/api/reconciliation/downloadReconciliationTemplate`, {}, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8",
                },
                responseType: "blob"
            }).then(res => {
                const link = document.createElement("a");
                let blob = new Blob([res.data], {
                    type: "application/vnd.ms-excel"
                });
                link.style.display = "none";
                link.href = URL.createObjectURL(blob);
                link.download = "对账单导入模板.xls";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
        },
        dc() {
            publicExport("/api/bdShop/exportShopPay", this.form, "对账信息")
        },
        dcAll() {
            // if (this.form.kpStatus == "") {
            // 	this.$message.warning("请选择开票状态！")
            // 	return
            // }
            this.dc2();

        },
        dc2() {

            let ids = []
            this.paymentBillVos.forEach(element => {
                if (element.kpStatus != "不可开票") {
                    ids.push(element.id)
                }
            });
            if (ids.length == 0) {
                this.$message.error("选中数据暂无可下载开票信息！")
                return
            }
            publicExport("/api/reconciliation/exportInvoice", { ids: ids.toString() }, "历史开票信息")
        },
        editShopPay(row, index) {
            this.bdShopPayList[index].editIs = "1";
        },
        saveShopPay(row, index) {
            if (row.money === '') {
                this.$message.error("请输入金额")
                return;
            }
            let data = {
                list: [
                    {
                        money: row.money,
                        type: row.type
                    }
                ],
                roomName: this.obj.roomName,
                time: row.appdate,
            }
            this.$http.post("/api/shopPay/update", data).then(res => {
                if (res.data.code == 0) {
                    this.$message.success(res.data.data)
                    this.bdShopPayList[index].editIs = "0";
                    this.getAll();
                } else {
                    this.$message.error(res.data.data)
                }

            })

        },
        checkChange(val) { //筛选列复选框被改变
            console.log(val)
            // val.forEach(val=>{
            // 	if(val=='')
            // })
            var newObj = {}
            for (var key in this.oldTitleObj) {
                if (val.indexOf(this.oldTitleObj[key]) != -1) {
                    newObj[key] = this.oldTitleObj[key]
                }
            }
            this.titleObj = newObj;
            if (val.length == 1) { //只有一列时,复选框禁止勾选
                this.oneRow = val[0];
                this.$message.warning("表格内容至少显示一列")
                return;
            }
            this.oneRow = ""
        },

        handleClose() {
            this.show = false
            this.isDyxs = true
        },
        downFil(item) {
            downloadFile(item)
        },
        changeRow(obj) {
            this.id = obj.id
            this.status = obj.status
            this.isChange = true
        },
        isOk() {
            this.$http.post("/api/shopPay/updateShopPay", {
                id: this.id,
                status: this.status
            }).then(res => {
                if (res.data.code == 0) {
                    this.$message.success(res.data.message)
                    this.isChange = false
                    this.getAll()
                }
                console.log(res)

            })
        },
        lookRow(obj) {
            this.sum = 0;
            this.$http.get(`/api/shopPay/selectOne?id=${obj.id}`).then(res => {
                if (res.data.code == 0) {
                    this.obj = res.data.data
                    res.data.data.bdShopPayList.forEach(val => {
                        val.editIs = "0"
                        this.sum = Math.floor(val.money * 100) / 100 + this.sum
                    })
                    this.bdShopPayList = JSON.parse(JSON.stringify(res.data.data.bdShopPayList))
                    this.show = true;
                } else {
                    this.$message.error("查询失败！")
                }
            })
        },
        fuheRow(row) {
            if (row.id) {
                this.dataIds = [];
                if (row.review == '未复核' && row.status == '已缴费' && row.wuyeStatus == '1' && row.promotionStatus == '1') {
                    this.dataIds.push(row.id)
                }
            }
            if (this.dataIds.length == 0) {
                this.$message({
                    type: 'warning',
                    message: '选中的数据暂不可复核！'
                });
                return
            }
            const id = this.dataIds.toString();
            this.$confirm('是否确认复核?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$http.post(`/api/shopPay/review`, { ids: id, review: '已复核' }).then(res => {
                    this.getAll();
                    this.$message.success("复核成功");
                })
                // return delDeployment(ids);
            }).catch(() => {
                this.$message({
                    type: 'warning',
                    message: '已取消复核'
                });
            });
        },
        handleCurrentChange(val) {
            this.form.page = val;
            this.getAll()
        },
        handleSizeChange(val) {
            this.form.row = val;
            this.getAll()
        },
        getUsers() { //查询申请人
            this.$http.get("/api/bdShopRenovation/getUserShop").then(res => {
                this.users = res.data.data
            })
        },
        querySeach() {
            this.form = {
                "time": "", //结束时间
                "roomName": "",
                "page": 1,
                "row": 10,
            };
            this.getAll();
        },
        query() {
            this.form.page = 1;
            this.getAll();
        },
        getAll() { //获取表格数据
            this.loading = true;
            this.$http.post("/api/reconciliation/waterEleList", this.form).then(res => {
                this.loading = false;
                if (res.data.code == 0) {
                    this.count = res.data.data.totalNum;
                    this.data = res.data.data.items
                }

            })
        },
    },

}
</script>

<style scoped="scoped">
.box {
    font-size: 16px;
    width: 70%;
}

.box>div {
    margin-bottom: 10px;
}
</style>
